module.exports = __webpack_public_path__ + "static/media/towardsRight.b27aff12.svg";